export class Relatorio {
    urlStorage:string;
    htmlHeader: string;
    htmlBody: string;
    scriptBody: string;
    scriptHeader: string;
    nomeRelatorio:string;
    headerData:any;
    bodyData: any;
}